import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  const breadcrumbItems = [
    { label: '首页', path: '/' },
    { label: '关于我们' },
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于木瓜影视 - 高清电视剧免费在线观看平台',
    description: '木瓜影视致力于为广大追剧爱好者提供高清电视剧全集免费在线观看服务，最新热播剧不缓冲无广告极速播放。',
    url: 'https://www.muguays.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '木瓜影视',
      url: 'https://www.muguays.com/',
    },
  };

  const milestones = [
    { year: '2018', title: '平台创立', desc: '木瓜影视正式上线，致力于打造优质的免费电视剧观看平台' },
    { year: '2019', title: '资源突破千部', desc: '电视剧资源库突破一千部，涵盖各类热门分类' },
    { year: '2020', title: '用户突破百万', desc: '月活跃用户突破百万，成为追剧爱好者的首选平台' },
    { year: '2021', title: '技术升级', desc: '全面升级播放技术，支持H5极速播放，告别卡顿和缓冲' },
    { year: '2022', title: '移动端优化', desc: '完成移动端全面适配，随时随地畅享追剧体验' },
    { year: '2023', title: 'AI推荐上线', desc: '引入智能推荐算法，为用户精准推荐感兴趣的电视剧' },
    { year: '2024', title: '资源全面升级', desc: '全面升级高清资源，4K超清画质带来极致观影体验' },
    { year: '2025', title: '持续创新', desc: '持续优化产品体验，新增弹幕互动、多线路切换等功能' },
  ];

  const reviews = [
    {
      name: '追剧达人小李',
      rating: 5,
      text: '用木瓜影视追剧快两年了，资源真的超级全！更新速度也很快，热播剧基本都是同步更新的。最赞的是没有广告打扰，观影体验非常棒！',
      date: '2025-07-15',
    },
    {
      name: '剧荒拯救者',
      rating: 5,
      text: '朋友推荐的这个平台，果然没让我失望。画质清晰、播放流畅，分类也很清晰，找剧特别方便。已经安利给身边所有追剧的朋友了！',
      date: '2025-06-28',
    },
    {
      name: '古装剧爱好者',
      rating: 5,
      text: '作为一个古装剧迷，木瓜影视的古装剧资源真的让我惊喜！从经典老剧到最新热播，应有尽有。播放不卡顿，画质也很清晰，大爱！',
      date: '2025-06-10',
    },
    {
      name: '悬疑控小王',
      rating: 4,
      text: '悬疑剧的分类做得很好，高分悬疑剧基本都有收录。《漫长的季节》和《隐秘的角落》都是在这里追完的。希望科幻类资源能再多一些就更好了。',
      date: '2025-05-22',
    },
    {
      name: '全家一起看',
      rating: 5,
      text: '家里的老人喜欢看年代剧和家庭剧，我喜欢看悬疑和科幻，女儿喜欢看古装剧。一家人各取所需，木瓜影视都能满足！真的是全家人的追剧神器。',
      date: '2025-05-08',
    },
    {
      name: '通勤追剧族',
      rating: 5,
      text: '每天上下班路上都在用手机追剧，木瓜影视的移动端体验做得特别好。加载快、不卡顿，而且可以自动记住播放进度，非常人性化！',
      date: '2025-04-20',
    },
  ];

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
      <main className="pt-16">
        <div className="bg-background-100/60">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6">
            <Breadcrumb items={breadcrumbItems} />
            <div className="mt-4">
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
                关于木瓜影视
              </h1>
              <p className="text-sm text-foreground-500 mt-2">
                高清电视剧免费在线观看平台，用心做好每一个细节
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-[1000px] mx-auto px-4 md:px-6 py-10">
          <section className="mb-12">
            <h2 className="text-xl font-heading text-foreground-900 mb-4">品牌介绍</h2>
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                木瓜影视成立于2018年，是一家专注于高清电视剧在线播放的综合服务平台。我们始终秉持"免费、高清、流畅"的服务理念，致力于为广大追剧爱好者提供最优质的在线观影体验。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                平台汇聚了海量高清电视剧资源，涵盖古装剧、都市剧、悬疑剧、爱情剧、科幻剧、喜剧、谍战剧、武侠剧、历史剧等多个分类。从经典老片到最新热播，从国产精品到海外佳作，木瓜影视应有尽有，满足不同用户的多样化追剧需求。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                我们拥有一支专业的技术和运营团队，每日对资源进行更新维护，确保内容的新鲜度和播放的流畅度。同时，我们采用先进的H5播放技术，用户无需安装任何插件即可享受极速播放体验。无论您是在家用电脑大屏观影，还是通勤时用手机追剧，木瓜影视都能为您提供畅快淋漓的观影体验。
              </p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-xl font-heading text-foreground-900 mb-4">发展历程</h2>
            <div className="space-y-0">
              {milestones.map((milestone, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div className="w-3 h-3 rounded-full bg-primary-500 shrink-0 mt-1.5"></div>
                    {index < milestones.length - 1 && (
                      <div className="w-px flex-1 bg-background-300 my-1"></div>
                    )}
                  </div>
                  <div className="pb-6">
                    <span className="text-xs font-semibold text-primary-500 bg-primary-50 px-2 py-0.5 rounded">
                      {milestone.year}
                    </span>
                    <h3 className="text-base font-semibold text-foreground-800 mt-1">{milestone.title}</h3>
                    <p className="text-sm text-foreground-500 mt-0.5">{milestone.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-xl font-heading text-foreground-900 mb-4">用户口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {reviews.map((review, index) => (
                <div
                  key={index}
                  className="bg-background-50 rounded-xl p-5 border border-background-200/70"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                      <span className="text-sm font-heading text-accent-600">
                        {review.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">{review.name}</p>
                      <div className="flex items-center gap-0.5 mt-0.5">
                        {Array.from({ length: 5 }, (_, i) => (
                          <i
                            key={i}
                            className={`text-xs ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-background-300'}`}
                          ></i>
                        ))}
                      </div>
                    </div>
                    <span className="ml-auto text-xs text-foreground-400">{review.date}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl font-heading text-foreground-900 mb-4">联系我们</h2>
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/70">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h3 className="text-base font-semibold text-foreground-800 mb-3">联系方式</h3>
                  <div className="space-y-3">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100">
                        <i className="ri-mail-line text-primary-500"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">电子邮箱</p>
                        <a href="mailto:service@muguays.com" className="text-sm text-foreground-800 hover:text-primary-500 transition-colors">
                          service@muguays.com
                        </a>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100">
                        <i className="ri-customer-service-line text-accent-500"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">客服热线</p>
                        <span className="text-sm text-foreground-800">400-888-6666</span>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100">
                        <i className="ri-time-line text-secondary-500"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">服务时间</p>
                        <span className="text-sm text-foreground-800">周一至周日 9:00 - 22:00</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-foreground-800 mb-3">关注我们</h3>
                  <div className="flex gap-3">
                    <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-500 transition-colors cursor-pointer group" aria-label="微信">
                      <i className="ri-wechat-line text-lg text-foreground-600 group-hover:text-background-50"></i>
                    </a>
                    <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-500 transition-colors cursor-pointer group" aria-label="微博">
                      <i className="ri-weibo-line text-lg text-foreground-600 group-hover:text-background-50"></i>
                    </a>
                    <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-500 transition-colors cursor-pointer group" aria-label="QQ">
                      <i className="ri-qq-line text-lg text-foreground-600 group-hover:text-background-50"></i>
                    </a>
                    <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200 hover:bg-primary-500 transition-colors cursor-pointer group" aria-label="哔哩哔哩">
                      <i className="ri-bilibili-line text-lg text-foreground-600 group-hover:text-background-50"></i>
                    </a>
                  </div>
                  <div className="mt-5 p-4 bg-background-100 rounded-lg">
                    <p className="text-xs text-foreground-500 leading-relaxed">
                      如果您在使用过程中遇到任何问题，或者有好的建议和意见，欢迎随时与我们联系。我们会在第一时间回复您，用心倾听每一位用户的声音，不断优化产品体验。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}